import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCurrentPartner } from 'services/repositories/partners/partners';
import { extractRelationshipVariables, RelationshipVariables } from 'support/helpers/relationships/relationships';
import { RelationshipV2 } from 'support/types';

export const buildTaskVariables = (
  extracted: RelationshipVariables | undefined,
  t: (key: string) => string,
): Record<string, string> => {
  if (!extracted) {
    return {};
  }
  return {
    partnerName: extracted.partnerName,
    messageType: t(`common:messageTypes.plural.${extracted.messageType}`).toLocaleLowerCase(),
    direction: t(`connections:direction.${extracted.direction}`),
  };
};

export const useTaskVariables = (
  relationship: RelationshipV2 | undefined,
  responsiblePartnerId?: string,
): Record<string, string> => {
  const { t } = useTranslation();
  const { data: currentPartner } = useCurrentPartner();

  return useMemo(() => {
    const effectivePartnerId = responsiblePartnerId ?? currentPartner?.id;
    if (!relationship || !effectivePartnerId) {
      return {};
    }
    const extracted = extractRelationshipVariables(relationship, effectivePartnerId);
    return buildTaskVariables(extracted, t);
  }, [relationship, responsiblePartnerId, currentPartner?.id, t]);
};

/**
 * i18n
 *
 * t('connections:direction.INBOUND')
 * t('connections:direction.OUTBOUND')
 *
 */
